import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

import RecordItem from './RecordItem';

type RecordProps = {
  items: any[];
  isLoading?: boolean;
  onChange: (index: number, fieldName: string, value: number | null) => void;
};

const Record: React.FC<RecordProps> = (props) => {

  return (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: 'none',
        '& *': { color: 'primary.dark', fontSize: '12px' },
        maxHeight: 'calc(100vh - 320px)',
        maxWidth: '700px'
      }}
    >
      <Table
        stickyHeader
        sx={{
          '& .MuiTableCell-root.MuiTableCell-head': {
            borderBottom: '1px solid #F3F3F3',
            fontWeight: 700,
            fontSize: '14px',
            height: '36px',
            p: '0px 16px'
          }
        }}
        aria-label='simple table'>
        <TableHead >
          <TableRow >
            <TableCell align={'left'} width={'180px'} sx={{ bgcolor: 'primary.light' }}>医師</TableCell>
            <TableCell align={'left'} width={'260px'} sx={{ bgcolor: 'primary.light' }}>変動率 通常価格</TableCell>
            <TableCell align={'left'} width={'260px'} sx={{ bgcolor: 'primary.light' }}>変動率 モニター価格</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!props.isLoading ? (
            props.items.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={11}
                  sx={{ textAlign: 'center', verticalAlign: 'center' }}
                >
                  データがありません
                </TableCell>
              </TableRow>
            ) : (
              props.items.map((item, index) => (
                <RecordItem
                  key={index}
                  item={item}
                  index={index}
                  onChange={props.onChange}
                />
              ))
            )
          ) : (
            <TableRow>
              <TableCell colSpan={3}>
                <Stack spacing={1}>
                  <Skeleton variant='rounded' width={'100%'} height={40} />
                  <Skeleton variant='rounded' width={'100%'} height={40} />
                  <Skeleton variant='rounded' width={'100%'} height={40} />
                </Stack>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Record;
